export const homeCarouselData=[
    {
        image:"https://www.lavanyathelabel.com/cdn/shop/files/weddddding_0deb8aad-4f81-4ffd-8f73-22d1670bf587.jpg?v=1700120957&width=1400",
        path:"/women/clothing/women_dress"
    },
    {
        image:"https://www.lavanyathelabel.com/cdn/shop/files/saree_pc_1b94c0b4-e87d-4cba-a195-ae4ff16506e9.jpg?v=1700729588&width=1400",
        path:"/women/clothing/women_dress"
    },
    {
        image:" https://www.lavanyathelabel.com/cdn/shop/files/lehenga_pc_1f62cf1e-a0db-4643-9169-0a9a95e63b10.jpg?v=1700729588&width=1400",
        path:"/women/clothing/women_dress"
    },
    {
        image:"https://www.lavanyathelabel.com/cdn/shop/files/ethnc_pc.jpg?v=1700729588&width=1400",
        path:"/women/clothing/women_saree"
    },
    {
       image:" https://www.soch.com/media/wysiwyg/HB_banner_Desktop_21.jpg",
       path:"/women/clothing/women_dress"
    }

]

